import { CampaignBillingDetails } from '~/lib/types/Campaign'

export const createCampaignBillingDetailsMock = (mock?: Partial<CampaignBillingDetails>): CampaignBillingDetails => ({
  all: {
    offerCount: mock?.all?.offerCount ?? 20,
    amount: mock?.all?.amount ?? 200000,
  },
  working: {
    offerCount: mock?.working?.offerCount ?? 10,
    amount: mock?.working?.amount ?? 100000,
  },
  completed: {
    offerCount: mock?.completed?.offerCount ?? 10,
    amount: mock?.completed?.amount ?? 100000,
  },
})
